import { useDisclosure } from "@chakra-ui/hooks";
import { getSignedUrl } from "api/admin";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import CircleButton from "./circle-button";
import { t } from "i18next";
import { MdPhoto } from "react-icons/md";
import GenericDialog from "widgets/dialogs/generic";

const PhotoButton = (props: { imageSrc: string; context?: string; imageKey?: string; color?: "primary" | "secondary" | "tertiary" | "white" | string; }) => {
  const { imageSrc, context, imageKey, color = 'white' } = props;
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const handleClick = async () => {
    if (imageKey && !imageKey.startsWith("https")) {
      dispatch(setLoading(true));
      const { data, isLoading } = await getSignedUrl(imageKey);
      dispatch(setLoading(isLoading));
      setImageUrl(data?.signedUrl || imageSrc); // Use the signed URL or fallback to the original imageSrc
    } else {
      setImageUrl(imageKey);
    }
    onOpen(); // Open the dialog after setting the image URL
  };

  return (
    <div>
      {imageKey ? (
        <div className="flex flex-col items-center justify-center">
          <CircleButton
            icon={MdPhoto}
            size="xxl"
            variant="ghost"
            onClick={handleClick}
            tooltip={t('tooltip.photo', context)}
            tooltipPlacement="bottom"
            color={color}
          />
          <div className="text-white text-txt-xs text-center">{t('photo.label', {context: context})}</div>
        </div>
      ) : null}
      <GenericDialog
        isOpen={isOpen}
        onExit={onClose}
        title={t('photo.label', {context: context})}
        size="md"
      >
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Modal content"
            style={{ width: "100%", borderRadius: "20px" }}
          />
        )}
      </GenericDialog>
    </div>
  );
};

export default PhotoButton;
